import React, {Component} from 'react';
import {connect} from "react-redux";
import * as actions from "../../../../../../actions";
import Loading from "react-loading-animation";
import api from "../../../../../../util/clipstore/user/api";
import {Col, TabPane} from "reactstrap";
import * as _ from "lodash";
import InfiniteScroll from "react-infinite-scroll-component";
import HomeCardComponent from "../../../../../../components/clipstore/user/home/card";

class AttachmentMyLibraryTab extends Component {

    constructor() {
        super();
        this.state = {
            width: 294,
            height:164,
            searchValue:'',
            sortBy: 'new',
            currentPage: 1,
            totalPages: 1,
            currentItems: 12,
            totalItems: 12,
            reset: false,
            hasMore: true,
            content: {},
            contentList: [],
        }
    }

    componentDidMount() {
        api.getMyLibraryAPI(this.props, {
            width: this.state.width,
            height: this.state.height,
            searchValue: this.state.searchValue,
            sortBy: this.state.sortBy,
            page: this.state.currentPage,
        });
    }

    loadNextPage = () => {
        let currentPage = this.state.currentPage;
        currentPage = currentPage + 1;

        this.setState({
            currentPage
        }, () => {
            api.getMyLibraryAPI(this.props, {
                width: this.state.width,
                height: this.state.height,
                searchValue: this.state.searchValue,
                sortBy: this.state.sortBy,
                page: this.state.currentPage,
            });
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {

        //this will be called for every pagination we perform
        if (nextProps.get_my_library && nextProps.get_my_library.payload !== this.props.get_my_library.payload) {

            if (nextProps.get_my_library.payload &&
                nextProps.get_my_library.payload.hasOwnProperty("data")) {

                let data = nextProps.get_my_library.payload.data;
                let contentList = data;

                if (this.state.currentPage !== 1) {
                    if (contentList.length > 0) {
                        contentList = this.state.contentList.concat(nextProps.get_my_library.payload.data.data)
                    } else {
                        contentList = this.state.contentList;
                    }
                }

                //fast switching causes to show duplicates
                contentList = _.uniqBy(contentList, function (e) {
                    return e.id;
                });

                this.setState({
                    currentPage: parseInt(data.current_page),
                    hasMore: parseInt(data.current_page) <= parseInt(data.last_page),
                    totalPages: parseInt(data.last_page),
                    currentItems: parseInt(data.current_page) * data.length,
                    totalItems: parseInt(data.total),
                    contentList,
                    reset: false
                }, () => {
                    console.log("contentList", this.state.contentList)
                    if (this.state.hasMore && this.state.currentPage < 3) {
                        this.loadNextPage();
                    }
                })
            }
        }
    }

    render() {
        return (
            <TabPane tabId="my-library">
                <Col sm="12" className="bg-white p-3 rounded">
                    <InfiniteScroll
                        height={420}
                        dataLength={this.state.contentList.length}
                        next={this.loadNextPage}
                        hasMore={this.state.hasMore}
                        loader={<Loading/>}
                        endMessage={<span/>}
                    >

                        {
                            this.state.contentList.map((content, index) => {
                                return (
                                    <HomeCardComponent
                                        openBroadcasterProfile={() => {
                                        }}
                                        showBroadcasterSection={false}
                                        isCheckBox
                                        selectedItems={this.props.selectedItems}
                                        selectCard={(content) => {
                                            console.log("selectCard", content)
                                            this.props.setSelectedItem(content);
                                        }}
                                        openDetail={() => {
                                        }}
                                        content={content}
                                        key={`published-content-component-${index}`}/>
                                )
                            })
                        }
                    </InfiniteScroll>
                </Col>

            </TabPane>
        );
    }
}

AttachmentMyLibraryTab.propTypes = {};

function mapStateToProps(state, ownParams) {
    return {
        device: state.device.payload,
        get_my_library: state.clipstore_broadcaster_get_my_library,
    };
}

export default connect(mapStateToProps, actions)(AttachmentMyLibraryTab);
